import { Fragment } from "react";

const URL_RE = /(https?:\/\/[^\s<]+[^\s<.,;:!?)"'\]]|www\.[^\s<]+[^\s<.,;:!?)"'\]])/gi;

function escapeRe(s) {
  return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

/**
 * Texto de un mensaje: respeta saltos de línea, convierte URLs en enlaces y resalta @menciones.
 * `nombresMencion` son los nombres (sin @) de las personas mencionadas en el mensaje.
 */
export function RichText({ texto, nombresMencion = [], propio = false }) {
  const str = String(texto || "");
  const nombres = nombresMencion.filter(Boolean).sort((a, b) => b.length - a.length);
  const mentionRe = nombres.length ? new RegExp(`(@(?:${nombres.map(escapeRe).join("|")}))`, "g") : null;

  const renderMenciones = (fragmento, keyBase) => {
    if (!mentionRe) return fragmento;
    return fragmento.split(mentionRe).map((parte, i) =>
      i % 2 === 1 ? (
        <span key={`${keyBase}-m${i}`} className={propio ? "font-semibold underline decoration-white/40" : "font-medium text-primary bg-primary/10 rounded px-0.5"}>
          {parte}
        </span>
      ) : (
        <Fragment key={`${keyBase}-t${i}`}>{parte}</Fragment>
      )
    );
  };

  return (
    <span className="whitespace-pre-wrap break-words [overflow-wrap:anywhere]">
      {str.split(URL_RE).map((parte, i) =>
        i % 2 === 1 ? (
          <a
            key={i}
            href={parte.startsWith("http") ? parte : `https://${parte}`}
            target="_blank"
            rel="noopener noreferrer"
            className={propio ? "underline decoration-white/60" : "text-primary underline"}
            onClick={(e) => e.stopPropagation()}
          >
            {parte}
          </a>
        ) : (
          <Fragment key={i}>{renderMenciones(parte, i)}</Fragment>
        )
      )}
    </span>
  );
}

export function extraerUrls(texto) {
  return String(texto || "").match(URL_RE) || [];
}
